import { useEffect, useRef } from 'react';
import { useFailedNotifications } from '@/api/hooks/useNotifications';
import { useNotificationStore } from '@/stores/notificationStore';

/** Pushes each newly failed customer message into the bell (once per failure). */
export function useFailedNotificationAlerts() {
  const { data } = useFailedNotifications();
  const addNotification = useNotificationStore((state) => state.addNotification);
  const seen = useRef(new Set<string>());

  useEffect(() => {
    for (const item of data ?? []) {
      const key = `${item.ticketId}|${item.failedAt}`;
      if (seen.current.has(key)) continue;
      seen.current.add(key);
      addNotification({
        title: 'הודעה ללקוח לא נשלחה',
        message: `${item.customerName} · קריאה ${item.ticketNumber}`,
        type: 'error',
        actionUrl: `/tickets/${item.ticketId}`,
        persistent: true,
      });
    }
  }, [data, addNotification]);
}
